export const FETCH_STORE_PRODUCT_COUNT_UPDATE =
  'FETCH_STORE_PRODUCT_COUNT_UPDATE';
export const FETCH_PRODUCTS_INFO_UPDATE = 'FETCH_PRODUCTS_INFO_UPDATE';
export const CLEAR_PRODUCTS_INFO = 'CLEAR_PRODUCTS_INFO';
